import { ApiClient, PagedResults, ServiceResponse } from "../../../common";
import { PlatformSettings } from "../../../settings/platformSettings";
import ExpiringAppSecretsDto from "../../dtos/out/expiringAppSecretsDto";
import { IReports } from "../interfaces/reports";

export default class Reports extends ApiClient implements IReports {
    private _baseUrl: string;
    constructor(private platformSettings: PlatformSettings) {
        super();
        this._baseUrl = platformSettings.apiUrl + "/auth";
    }

    get baseUrl(): string {
        return this._baseUrl;
    }

    public async getExpiringAppSecrets(
        page: number = 1,
        pageSize: number = 25,
        days: number = 7,
        orderBy: string = "expiryDate",
        platformAppsOnly: boolean = false,
        accessToken: string): Promise<ServiceResponse<PagedResults<ExpiringAppSecretsDto>>> {

        let endpoint = `reports/expiring-app-secrets?page=${page}&pageSize=${pageSize}&days=${days}&orderBy=${orderBy}&platformAppsOnly=${platformAppsOnly}`;

        return await super.Get<PagedResults<ExpiringAppSecretsDto>>(
            this.baseUrl,
            endpoint,
            accessToken);
    }
}

export { Reports }